import React from 'react';
import RecaptchaContainter from 'common/components/Recaptcha/RecaptchaContainter';

const RecaptchaField = (props) => {
  const updateCaptchaVerifiedField = (newValue) => {
    const { name, onChangeCustomComponent } = props.input;
    onChangeCustomComponent(newValue, name);
  };
  const onSuccess = () => updateCaptchaVerifiedField(true);
  const onExpired = () => updateCaptchaVerifiedField(false);

  return <RecaptchaContainter onSuccess={onSuccess} onExpired={onExpired} />;
};

export default RecaptchaField;



// WEBPACK FOOTER //
// ./src/common/components/fields/RecaptchaField.jsx